import * as React from 'react';
import { Text, TokenTextAppearance } from '../../text';
import { MediaContext } from '..';
export const TimeDisplay = () => {
    const mediaElement = React.useContext(MediaContext);
    const [timeString, setTimeString] = React.useState('00:00');
    const handleTimeupdate = React.useCallback(() => {
        const duration = (mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.duration) || 0;
        const currentTime = (mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.currentTime) || 0;
        const roundedTimeStamp = Math.round(duration - currentTime);
        const minutes = `${Math.floor(roundedTimeStamp / 60)}`.padStart(2, '0');
        const seconds = `${roundedTimeStamp % 60}`.padStart(2, '0');
        setTimeString(`${minutes}:${seconds}`);
    }, [mediaElement]);
    React.useEffect(() => {
        handleTimeupdate();
        mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.addEventListener('timeupdate', handleTimeupdate);
        return () => {
            mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.removeEventListener('timeupdate', handleTimeupdate);
        };
    }, [handleTimeupdate, mediaElement]);
    return React.createElement(Text, { appearance: TokenTextAppearance.label150 }, timeString);
};
TimeDisplay.displayName = 'TimeDisplay';
